import { getSwatchImageUrl } from 'utils/utils';
import { Product } from '../types';

type SwatchProps = {
  showName?: boolean;
  style?: object;
  swatch: Product;
  swatchSize?: number;
} & ClassNameProp;

const Swatch = ({ className, showName = false, style, swatch, swatchSize = 60 }: SwatchProps) => (
  <div className={className} data-testid="swatch" style={{ width: swatchSize, height: swatchSize }}>
    <img src={getSwatchImageUrl(swatch, swatchSize)} alt="swatch image" loading="lazy" style={style} />
    {showName && <div className="mt-4 text-center text-xs leading-tight">{swatch.displayName}</div>}
  </div>
);

export default Swatch;
